import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, ContentChild, Input, input } from '@angular/core';

import { ButtonComponent } from '../../../../common/button/components/button/button.component';
import { DividerComponent } from '../../../../common/divider/divider.component';
import { HeadingComponent } from '../../../../common/heading/heading.component';
import { IconHelpComponent } from '../../../../common/icon/icon-help/icon-help.component';
import type { IconSize } from '../../../../common/icon/icon.component';
import { IconComponent } from '../../../../common/icon/icon.component';
import type { IconName } from '../../../../common/icon/icons.type';
import { TabsComponent } from '../../../../common/tabs/tabs.component';
import { RtTooltip } from '../../../../common/tooltip/tooltip.directive';
import { ComponentVariantTransform, type Variants } from '../../../../utils/variant/variant';

@Component({
  selector: 'rt-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-actions]': 'newButton || actionsSlot()',
    '[class.has-tabs]': 'tabs',
    '[class.has-padding]': 'hasPadding()',
    '[class.blue-bg]': 'hasBlueBg()',
    '[class]': 'variant()',
  },
  imports: [
    DividerComponent,
    HeadingComponent,
    IconComponent,
    IconHelpComponent,
    NgTemplateOutlet,
    RtTooltip,
  ],
})
export class DialogHeaderComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'dark', 'no-padding', 'no-bottom-padding'],
  ];

  public readonly variant = input(...ComponentVariantTransform(DialogHeaderComponent.VARIANTS));
  public readonly hasDivider = input<boolean>(true);
  public readonly hasPadding = input<boolean>(false);
  public readonly hasBlueBg = input<boolean>(false);
  public readonly iconSize = input<IconSize>('large-x');
  public readonly iconMarginLeft = input<boolean>(true);
  public readonly actionsSlot = input<TemplateRef<any>>(undefined!);
  public readonly badgesTpl = input<TemplateRef<any> | null>(null);
  public readonly stepText = input<string>('');

  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public icon: IconName;
  @Input() public hint: string;
  @Input() public subheadingTpl: TemplateRef<any> | null = null;
  @Input() public headingTpl: TemplateRef<any> | null = null;

  @ContentChild(ButtonComponent)
  public newButton: ButtonComponent;

  @ContentChild(TabsComponent)
  public tabs: TabsComponent;
}
